define('modules/htmlad/template/htmlad_template_model',['backbone',
  'session',
  '_',
  'modules/form/form_item_collection',
  'modules/form/form_section_model'
], function (Backbone, session, _,
             FormItemCollection,
             FormSectionModel) {
  'use strict';
  var Model = Backbone.Model.extend({
    defaults: function () {
      return {
        title: ''
      };
    },

    parse: function (response, options) {
      var respond = {},

        sections = new Backbone.Collection();

      response.previews.forEach(function (preview) {
        preview.preview = session.get('apiBaseUrl') + '/' + preview.preview;
      });

      _.forEach(response.sections, function (section) {
        var sectionModel = new FormSectionModel(section);

        var itemCollection = new FormItemCollection(section.fields);
        sectionModel.set({fields: itemCollection});
        sections.add(sectionModel);
      });

      delete response.sections;

      _.extend(respond, response);
      _.extend(respond, {sections: sections});

      return respond;
    },

    urlRoot: function () {
      return session.get('apiUrl') + 'htmltemplates';
    }

  });

  return Model;
});

